<template>
  <div
    class="py-2 px-3 text-sm text-gray-600 border-2 focus:border-blue-500 block w-full rounded-lg mb-2 bg-gray-100 animate-pulse outline-none uppercase"
    v-show="loading">
    Cargando tipo de pago
  </div>
  <select
    class="py-2 px-3 text-sm text-gray-600 uppercase border-2 focus:border-blue-500 block w-full rounded-lg mb-2 bg-gray-50 outline-none cursor-pointer"
    v-model="vModelSelectOptions" @change="sendDataSelect" v-show="!loading" id="idTypeOfPayment">
    <option :value="null" disabled>Selecciona un tipo de pago</option>
    <option v-if="!registers.length" :value="null" disabled>No hay tipos de pago disponibles</option>
    <option :value="resgiter.id" v-for="(resgiter, i) in registers" :key="i">
      {{ resgiter.descripcion }}
    </option>
  </select>
</template>
<script>
import { onMounted, ref } from "vue";
import axios from "../../api";
import { errorActions } from "@/alerts";
export default {
  name: "TypeOfPayment",
  props: {
    selectOption: {
      type: Number,
      required: false,
    },
  },
  emits: ['send-data'],
  setup(props, { emit }) {
    const registers = ref([]);
    const loading = ref(true);
    const vModelSelectOptions = ref(1);

    //funcion para enviar datos desde este componente hacia el otro componente
    const sendDataSelect = () => {
      emit("send-data", vModelSelectOptions.value);
    };
    onMounted(async () => {
      try {
        const response = await axios.get("tipo-de-pagos");
        registers.value = response?.data?.data ?? [];

        if (registers.value.length === 0) {
          errorActions(
            "Lo sentimos no hemos encontrado un tipo de pago en nuestra base de datos"
          );
          return;
        }

        const selectedByProp = registers.value.find(
          (register) => Number(register.id) === Number(props.selectOption)
        );
        const cashPayment = registers.value.find(
          (register) =>
            String(register.descripcion || "").trim().toUpperCase() === "EFECTIVO"
        );
        const fallback = registers.value[0] ?? null;

        vModelSelectOptions.value =
          selectedByProp?.id ?? cashPayment?.id ?? fallback?.id ?? null;

        if (vModelSelectOptions.value !== null) {
          emit("send-data", vModelSelectOptions.value);
        }
      } catch (error) {
        errorActions(error);
      } finally {
        loading.value = false;
      }
    });
    return {
      registers,
      loading,
      vModelSelectOptions,
      sendDataSelect,
    };
  },
};
</script>
